import React, { useState } from "react";
import { Box, Checkbox, List, ListItem, ListItemText, Typography, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

function FrameworkSelector({ frameworks, selectedFrameworks, handleToggle }) {
  const { t } = useTranslation(["gap-analysis", "common"]);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredFrameworks = frameworks.filter((framework) =>
    framework.sourceIdentifier.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalSelectedControls = selectedFrameworks.reduce(
    (total, framework) => total + (framework.controlCount ?? 0),
    0
  );

  return (
    <Box display="flex" gap={3} padding={3} data-tour="framework-selector">
      <Box flex={1} border="1px solid #ccc" borderRadius={2} padding={2}>
        <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom={1}>
          <Typography variant="h6">{t("gap-analysis:form.frameworks.chooseTitle")}</Typography>
          <TextField
            label={t("common:buttons.search")}
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Box>
        <List sx={{ maxHeight: "300px", overflowY: "auto" }}>
          {filteredFrameworks.length > 0 ? (
            filteredFrameworks.map((framework) => (
              <ListItem
                key={framework._id}
                button
                onClick={() => handleToggle(framework)}
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Checkbox
                  checked={selectedFrameworks.some((item) => item._id === framework._id)}
                  sx={{ width: "40px", padding: 0 }}
                />
                <ListItemText
                  primary={framework.sourceIdentifier}
                  secondary={t("gap-analysis:form.frameworks.controlsCount", { count: framework.controlCount ?? 0 })}
                />
              </ListItem>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              {t("gap-analysis:form.frameworks.notFound")}
            </Typography>
          )}
        </List>
      </Box>

      <Box flex={1} border="1px solid #ccc" borderRadius={2} padding={2}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">
            {t("gap-analysis:form.frameworks.selectedTitle")}
          </Typography>
          <Typography variant="body1" color="primary">
            {t("gap-analysis:form.frameworks.totalControls", { count: totalSelectedControls })}
          </Typography>
        </Box>
        <List sx={{ maxHeight: "300px", overflowY: "auto" }}>
          {selectedFrameworks.length > 0 ? (
            selectedFrameworks.map((framework) => (
              <ListItem key={framework._id} button onClick={() => handleToggle(framework)}>
                <Checkbox checked sx={{ width: "40px", padding: 0 }} />
                <ListItemText
                  primary={framework.sourceIdentifier}
                  secondary={t("gap-analysis:form.frameworks.controlsCount", { count: framework.controlCount ?? 0 })}
                />
              </ListItem>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              {t("gap-analysis:form.frameworks.noneSelected")}
            </Typography>
          )}
        </List>
      </Box>
    </Box>
  );
}

export default FrameworkSelector;
